import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromAuthState from './state';

const getAuthState = createFeatureSelector<fromAuthState.State>(fromAuthState.authFeatureKey);

export const selectIsLoggedIn = createSelector(getAuthState, state => state.isLoggedIn);
